import api from "./api";

export const entryReportService = {

  // 📅 Date wise
  getByDate: async (date) => {
    try {
      const res = await api.get(`/find-entry-bike-details/${date}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  // 📊 Weekly
  getWeekly: async (year) => {
    try {
      const res = await api.get(`/find-entry-bike-weekly-details/${year}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  // 📈 Monthly
  getMonthly: async (year, month) => {
    try {
      const res = await api.get(`/find-entry-bike-monthly-details/${year}/${month}`);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

};